import { clientsHideTabs } from '../config';

export const hideTabs = (totals = {}, from = '', source) => {
  const client = source;
  if (!clientsHideTabs.includes(client)) return totals;

  // Important: never `delete` from arrays (it creates holes and can crash
  // downstream sorts/renders when entries become `undefined`).
  if (Array.isArray(totals)) {
    if (from === 'report') return totals;
    return totals.filter((_, index) => index !== 1 && index !== 2);
  }

  const nextTotals = { ...totals };
  if (from === 'report') {
    delete nextTotals.psa_profil;
    delete nextTotals.psa;
  } else {
    delete nextTotals[1];
    delete nextTotals[2];
  }
  return nextTotals;
};
